<template>
    <div>
         <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list!=null">
            <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Get Division Time Table</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <v-card-text> -->
                <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Get Division Time Table</h3>
                    </v-col>
                </v-row> -->
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="sel_ay_data" return-object :items="ay_std_div_list" 
                        item-text="ay" 
                        label="Academic Year" 
                        outlined @change="getDiv();getTimeTableVersion();tt_version = null;" 
                        persistent-hint hint="Please Select Academic Year"
                        />
                    </v-col>
                    <v-col sm="2" v-if="div_list!=null">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="div" return-object :items="div_list" 
                        item-text="div" 
                        label="Division"                         
                        outlined 
                        persistent-hint hint="Please Select Division"
                        />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="tt_version" :items="tt_version_list"
                        item-text="name" item-value="id" label="Version" outlined @change="getData" persistent-hint
                        hint="Please Select Version" />
                </v-col>
                </v-row>
        </v-card>
        <div-time-table v-if="show_tt==true" :div_id="div.div_id" :tt_version="tt_version"></div-time-table>
    </div>
</template>
<script>
    import axios from "axios";
     import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import DivTimeTable from "./DivTimeTable";
    export default {
        components: {
            "div-time-table": DivTimeTable,
        },
        data() {
            return {
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                tt_version_list:[],
                tt_version:null
            };
        },
        methods: {
            getTimeTableVersion() {
            const data = {
                ay: this.sel_ay_data.ay,
            };
            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        // this.showSnackbar("success", "Success...");
                        this.tt_version_list = res.data.tt_version_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             getData() {
                //console.log("div:"+this.div)
                this.show_tt = true;
            },
            getDiv() {
               // alert(this.sel_ay_data)
                this.show_tt = false;
                const formData = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/timeTable/classTeacherTimeTable", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.div_list = res.data.div_off_list
                        } else  if (res.data.flag == "NO"){
                            this.showSnackbar("#32cd32", res.data.fmsg);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        
                    })
                    .finally(() => {
                      
                    });
            },
        },
        mounted() {
            //this.uid = localStorage.getItem("EPS-uid")
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                });
        },
    };
</script>
